import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function JoinTheMovement() {
  return <section data-section-id="232832" id="immediate-assistance-required" className="relative w-full overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500 via-blue-600 to-orange-500 opacity-90"></div>
        
        {}
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/water_texture_overlay.png')] opacity-20 mix-blend-overlay"></div>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-primary/20"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-transparent to-primary/30 opacity-80"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center gap-8">
        
        {}
        <div className="w-24 h-1 bg-white skew-x-[-20deg] mb-4 shadow-lg"></div>

        <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter text-white drop-shadow-2xl max-w-4xl leading-none">
          Don't Wait. <span className="text-primary">Water Moves Fast.</span>
        </h2>
        
        <p className="text-white/90 text-lg md:text-xl max-w-2xl font-medium mb-4 drop-shadow-md">
          Pueblo's fastest emergency referral network. Flood damage compounds by the hour — call now and get a certified local restoration professional on-site fast, 24/7.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 mt-4 w-full sm:w-auto">
          <Button asChild size="lg" className="h-14 px-8 text-lg font-bold uppercase tracking-wide rounded-md shadow-xl shadow-orange-950/40 hover:shadow-orange-500/50 transition-all bg-orange-500 text-white border-none animate-pulse">
            <Link to="/ContactPage">
              <span className="flex items-center gap-2">
                Call (719) 470-2769
                <ArrowRight className="size-5" />
              </span>
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg font-bold uppercase tracking-wide rounded-md border-2 border-white/50 text-white hover:border-white hover:bg-white/10 transition-all bg-white/5 backdrop-blur-md">
            <Link to="/ContactPage">
              <span>
                Request Callback
              </span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}